/**
 * BLOCK - BUNDLE PROGRESS BAR
 */

if (!customElements.get('bundle-progress-bar')) {
  customElements.define(
    'bundle-progress-bar',
    class BundleProgressBar extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          settings: '[data-settings]',
          settingsData: 'settings',
          finalTextData: 'finalText',
          progressMessage: '[data-progress-bar-message]',
          progressBar: '[data-progress-bar]',
          progressTreshold: '[data-treshold]',
        };

        this.selectors = selectors;
        this.type = this.dataset.type;

        this.init(); 
      }

      async init() {
        if (this.querySelector(this.selectors.settings) != null) {
          let settingsData = JSON.parse(this.querySelector(this.selectors.settings).dataset[this.selectors.settingsData]);
          let finalTextData = this.querySelector(this.selectors.settings).dataset[this.selectors.finalTextData];
          let progressMessage = this.querySelector(this.selectors.progressMessage);
          let progressBar = this.querySelector(this.selectors.progressBar);
          let progressTresholds = this.querySelectorAll(this.selectors.progressTreshold);
          let progressMaxTreshold = settingsData[settingsData.length - 1].treshold;
          let progressBarWidth = progressBar.offsetWidth;
          let progressBarPreviousStepPosition = 0;
          let progressBarPreviousStepTreshold = 0;
          let progressBarNextStepPosition = 1;
          let progressBarNextStepTreshold = parseInt(settingsData[0].treshold);
          let progressStepIndex = 0;
          let amountLeftForNextTreshold = 0;
          let nbItemsInBundle = 0;

          if (this.type == 'cart') {
            const cart = await this.getCartJSON();
            
            for (let index = 0; index < cart.items.length; index++) {
              if (cart.items[index].properties != undefined && cart.items[index].properties._isBundle) {
                nbItemsInBundle = nbItemsInBundle + cart.items[index].quantity;
              }
            }
  
            this.style.display = 'block';
            if (cart.items.length == 0) this.style.display = 'none';
          } else {
            let bundleSummaryProducts = document.querySelector('[data-bundle-summary-products]');

            if (bundleSummaryProducts !== null) nbItemsInBundle = parseInt(bundleSummaryProducts.dataset.productsCount);
          }

          for (let index = 0; index < settingsData.length; index++) {
            if (nbItemsInBundle >= parseInt(settingsData[index].treshold)) {
              progressTresholds[index].classList.add('active');
              progressBarPreviousStepPosition = index + 1;
              progressBarPreviousStepTreshold = parseInt(settingsData[index].treshold);

              if (index < settingsData.length - 1) {
                progressStepIndex = index + 1;
                progressBarNextStepPosition = index + 2;
                progressBarNextStepTreshold = parseInt(settingsData[progressStepIndex].treshold);
              } else {
                progressStepIndex = index;
                progressBarNextStepPosition = index + 1;
                progressBarNextStepTreshold = parseInt(settingsData[progressStepIndex].treshold);
              }
            } else {
              progressTresholds[index].classList.remove('active');
            }
          }

          let tresholdRange = progressBarNextStepTreshold - progressBarPreviousStepTreshold;
          let amountFromPreviousStep = nbItemsInBundle - progressBarPreviousStepTreshold;
          let percentFromPreviousStep = (amountFromPreviousStep * 100) / tresholdRange;

          let progressBarStepWidth = 100 / settingsData.length / 2;
          let progressBarPreviousStepWidth = (progressBarPreviousStepPosition * 2 - 1) * progressBarStepWidth;
          let progressBarNextStepWidth = (progressBarNextStepPosition * 2 - 1) * progressBarStepWidth;

          if (progressBarPreviousStepWidth < 0) progressBarPreviousStepWidth = 0;

          let widthRange = progressBarNextStepWidth - progressBarPreviousStepWidth;
          let percentDistanceFromPreviousStep = (widthRange * percentFromPreviousStep) / 100;

          if (nbItemsInBundle < parseInt(progressMaxTreshold)) {
            amountLeftForNextTreshold = progressBarNextStepTreshold - nbItemsInBundle;
            progressMessage.innerHTML = settingsData[progressStepIndex].text.replace('&#39;', "'");
            if (progressMessage.querySelector('span') !== null) {
              progressMessage.querySelector('span').textContent = amountLeftForNextTreshold;
              progressBarWidth = progressBarPreviousStepWidth + percentDistanceFromPreviousStep;
            }
          } else {
            progressMessage.innerHTML = finalTextData;
            progressBarWidth = 100;
          }

          progressBar.style.width = progressBarWidth + '%';

          if (this.type == 'pack') {
            let bundleSummaryMessage = document.querySelector('[data-bundle-summary-message]');
            bundleSummaryMessage.innerHTML = progressMessage.innerHTML;
          }
        }
      }

      async getCartJSON() {
        const result = await fetch('/cart.json');
      
        if (result.status === 200) {
          return result.json();
        }
      
        throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
      }
    }
  );
}